// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__LWcVj","navbar":"Navbar_navbar__zf2HN","toggler":"Navbar_toggler__H7zQd","active":"Navbar_active__gQgtl"};